import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'

class UserApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getInfoAboutMe() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users/me',
    })
  }

  public getUser(userId: number) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users/get-by-id',
      params: {
        user_id: userId,
      },
    })
  }
}

export const userApi = new UserApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
